import PropTypes from 'prop-types';
import React from 'react';

import {COLLABORATOR_SHAPE, OWNER_INFO_SHAPE, PERMISSIONS_SHAPE} from 'auth/PermissionConstants';
import {ENTITY_SHAPE} from 'constants/UserConstants';
import OwnableSettingsModal from 'create-components/OwnableSettingsModal';
import ModalAnchor from 'ui-library/ModalAnchor';
import SettingsPage from 'ui-library/SettingsPage';
import {capwords, typeToName} from 'util/NameUtil';

class OwnablePage extends React.Component {
  static propTypes = {
    ownableType: PropTypes.string.isRequired,
    ownable: PropTypes.shape({
      name: PropTypes.string.isRequired,
      owner: ENTITY_SHAPE.isRequired,
      description: PropTypes.string.isRequired,
      ownerInfo: OWNER_INFO_SHAPE.isRequired,
      permissions: PERMISSIONS_SHAPE,
    }).isRequired,
    collaborators: PropTypes.arrayOf(COLLABORATOR_SHAPE.isRequired),
    // If specified, an export icon will be shown that calls this callback.
    onExport: PropTypes.func,
    onRequestSubmit: PropTypes.func.isRequired,
    onRequestDelete: PropTypes.func.isRequired,
  };

  state = {
    isSettingsModalShown: false,
  };

  _handleChangeIsSettingsModalShown = (value) => {
    this.setState({isSettingsModalShown: value});
  };

  _getExistingOwnable = () => {
    const {name, description, ownerInfo, owner} = this.props.ownable;
    return {
      name,
      description,
      ownerInfo,
      collaborators: this.props.collaborators,
      owner,
    };
  };

  _handleSubmit = (updates) =>
    this.props.onRequestSubmit({
      ...updates,
      owner: updates.owner.handle,
    });

  render() {
    const friendlyType = capwords(typeToName(this.props.ownableType));
    return (
      <SettingsPage
        title={this.props.ownable.name}
        type={friendlyType}
        isSettingsShown={this.state.isSettingsModalShown}
        onChangeIsSettingsShown={this._handleChangeIsSettingsModalShown}
        onExport={this.props.onExport}
      >
        <div className="u-tiny-spacing-top">{this.props.ownable.description}</div>
        {this.state.isSettingsModalShown && (
          <ModalAnchor open={true}>
            <OwnableSettingsModal
              onRequestClose={() => this._handleChangeIsSettingsModalShown(false)}
              ownableType={this.props.ownableType}
              existingOwnable={this._getExistingOwnable()}
              doSubmit={this._handleSubmit}
              doDelete={this.props.onRequestDelete}
              showConfirmDelete={true}
              navigateOnSuccess={false}
              isReadOnly={!this.props.ownable.permissions.admin}
            />
          </ModalAnchor>
        )}
      </SettingsPage>
    );
  }
}

export default OwnablePage;
